import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import P1 from '@base/P1/P1';
import { getTime } from '@utils/dates';
import CardHeader from './CardHeader';
import Card from './Card';

const CardWrapper = styled.div``;

const StyledCard = styled(Card)`
  margin-top: 16px;
`;

const CardInfo = styled.div`
  display: flex;
`;

const SubTitle = styled.span`
  font-size: 12px;
  line-height: 150%;
  color: var(--color-text-secondary);
  margin-top: 8px;
`;

const WrappedDiv = styled.div`
  margin-left: 16px;
`;

const DateWrapper = styled.div`
  width: 40px;
  text-align: center;
`;

const Day = styled.span`
  font-weight: bold;
  font-size: 20px;
  line-height: 150%;
  color: var(--color-text-primary);
`;

const Month = styled.span`
  font-weight: 600;
  font-size: 12px;
  line-height: 150%;
  color: var(--color-text-primary);
  text-transform: uppercase;
  display: block;
`;

const Title = styled(P1)`
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: var(--color-text-primary);
`;

const NewClass = ({ story, batch }) => {
  const { message, created_at, object } = story;
  if (!object.title) return null;
  const pubDate = new Date(object.created_at);
  const day = pubDate.getDay();
  const month = pubDate.toLocaleString('default', { month: 'long' });
  return (
    <CardWrapper>
      <CardHeader
        message={message}
        created_at={created_at}
        img="newclass.svg"
        subtitle={batch && object?.collection?.name}
      />
      <StyledCard>
        <CardInfo>
          <DateWrapper>
            <Month>{month.slice(0, 3)}</Month>
            <Day>{day}</Day>
          </DateWrapper>
          <WrappedDiv>
            <Title>{object.title}</Title>
            <SubTitle>{getTime(object.created_at)}</SubTitle>
          </WrappedDiv>
        </CardInfo>
      </StyledCard>
    </CardWrapper>
  );
};

export default NewClass;

NewClass.propTypes = {
  story: PropTypes.objectOf(PropTypes.any).isRequired,
  batch: PropTypes.bool
};

NewClass.defaultProps = {
  batch: false
};
